import React, { forwardRef } from "react";
import accessibleGoldenDropdown from "../AccessibleGoldenDropdown";
import OverflowingText from "../../OverflowingText/OverflowingText";
import FilledButton from "../../SelectButton/FilledButton";
import EmptyButton from "../../SelectButton/EmptyButton";

const ReportTypeDropdown = forwardRef(
  (
    {
      OPTIONS,
      optionRefs,
      isOpen,
      reportTypeOptions,
      allDenomination,

      showArrow,
      focusedIndex,
      selected,
      selectedIndex,
      headingValue,
      setHeadingValue,
      position,

      handleOptionKeyDown,
      selectOption,
      restrictHover,
      accessibilityValues,

      popupClassName = {
        open: "",
        close: "",
        wrapperClass: "",
        containerClass: "",
        popupMenuClass: "",
      },
    },
    // ref,
  ) => {
    return (
      <div
        role={accessibilityValues.ariaHaspopup}
        id={accessibilityValues.ariaControls}
        aria-label={accessibilityValues.ariaLabel}
        className={`popup_menu ${popupClassName.popupMenuClass || ""}  ${
          showArrow === false ? "no_arrow" : ""
        } ${isOpen ? "popup_menu_open" : "popup_menu_close"}`}
        style={{ ...position }}
      >
        <div className="portfolio_report_accounts_container portfolio_report ul-list">
          {OPTIONS.map((report, index) => {
            const isSelected = selectedIndex === index;
            const isSelectedAccount = report.key === headingValue?.type?.key;
            const isClickable =
              reportTypeOptions.isCombined || allDenomination[report.apiValue];

            return (
              <div
                key={report.key}
                ref={(el) => (optionRefs.current[index] = el)}
                role="radio"
                aria-checked={isSelected}
                aria-disabled={!isClickable}
                tabIndex={!isClickable ? -1 : focusedIndex === index ? 0 : -1}
                onKeyDown={(e) => {
                  if (isClickable && (e.key === "Enter" || e.key === " ")) {
                    setHeadingValue(report);
                  }
                  if (!(!isClickable && (e.key === "Enter" || e.key === " ")))
                    handleOptionKeyDown(e, index);
                }}
                onClick={() => {
                  if (!isClickable) return;
                  setHeadingValue(report);
                  selectOption(index);
                }}
                className={`account_listitem  ${isClickable ? "cursor" : "cursor_block"}`}
              >
                <div className="radio_btn_input">
                  {isSelectedAccount ? <FilledButton /> : <EmptyButton />}
                </div>
                <label className="radio_btn_label cursor" htmlFor={report.key}>
                  <OverflowingText
                    text={report?.name || "Not Selected"}
                    width={160}
                    textClassName="radio_btn_label cursor_imp"
                    tooltipOnHover={true}
                    position="left"
                    tooltipClassName={
                      index === 0
                        ? "accounts_tooltip_styles_bottom"
                        : "accounts_tooltip_styles"
                    }
                  />
                </label>
              </div>
            );
          })}
        </div>
      </div>
    );
  },
);

export default accessibleGoldenDropdown(ReportTypeDropdown);
